import { runInAction } from 'mobx';
import { getOrder } from '../../../selectors/order/get-order';
import { orderDomainStore } from '../../../store';
import { assertIsStandardOrder } from '../../../utils/order-type-utils';
/**
 * Stores an added [[OrderTicketRedemptionCard]], along with its redemption details.
 */
export const storeTicketRedemptionCard = (details) => {
    const { ticketRedemptionCard, redemptionLimit } = details;
    const order = getOrder();
    assertIsStandardOrder(order, 'Cannot store ticket redemption card');
    runInAction(() => {
        order.ticketRedemptionCards.push(ticketRedemptionCard);
        orderDomainStore.data.orderTicketRedemptionCardRedemptionDetailsById[ticketRedemptionCard.id] = {
            ticketRedemptionCardId: ticketRedemptionCard.id,
            addedAt: new Date(),
            redemptionLimit
        };
    });
};
